
    import Auth from '@/components/AuthApollo/Auth';

    export default {
        name: 'SigninModal',

        components: {
            Auth,
        },

        props: {
            seeker: {
                type: Object,
                default: () => { return {}; },
            },
        },

        data() {
            return {
                isOpen: true,
            };
        },

        created() {
            this.openModal();

            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.back();

                next(false);
            });

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard();
            });
        },

        beforeDestroy() {
            this.closeModal();
        },

        methods: {
            back() {
                this.closeModal();
            },

            close() {
                this.$emit('close');
            },

            openModal() {
                this.isOpen = true;
            },

            closeModal() {
                this.isOpen = false;
            },
        },
    };
